import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { MarkerService } from '../../../../services/marker.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-call-assistance-btn',
  standalone: true,
  imports: [ButtonModule, CommonModule],
  templateUrl: './call-assistance-btn.component.html',
  styleUrl: './call-assistance-btn.component.css',
})
export class CallAssistanceBtnComponent {

  $servicingAORPhone!: Observable<string>;

  constructor(private markerService: MarkerService) {
    this.$servicingAORPhone = this.markerService.$servicingAORPhone;
  }

  makeCall(phoneNumber: string) {
    window.location.href = `tel:${phoneNumber}`;
  }
}
